export default __webpack_public_path__ + "static/media/w_f_2022_h.36e646fb.jpeg";